import { render, staticRenderFns } from "./ScheduleAnnouncement.vue?vue&type=template&id=3775270f&scoped=true&"
import script from "./ScheduleAnnouncement.vue?vue&type=script&lang=js&"
export * from "./ScheduleAnnouncement.vue?vue&type=script&lang=js&"
import style0 from "./ScheduleAnnouncement.vue?vue&type=style&index=0&id=3775270f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3775270f",
  null
  
)

export default component.exports